import Component from '@bythepixel/component-loader';

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY2ltYXJyb250cmFpbGVycyIsImEiOiJja21lYzJpZWowYTIxMnZvM20xdGdiOThhIn0.O6sNFGLk3Wo7ZiYFZkdN2w';
const DEBOUNCE_MS = 400;

function geocodeZip(zip) {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(zip)}.json`
    + `?types=postcode&country=us,ca&limit=1&access_token=${MAPBOX_TOKEN}`;

  fetch(url)
    .then((res) => res.json())
    .then((data) => {
      if (data.features && data.features.length > 0) {
        const [lng, lat] = data.features[0].center;
        document.dispatchEvent(new CustomEvent('dealer-locator:sort-by-location', {
          detail: { lat, lng },
        }));
      }
    })
    .catch(() => {});
}

export default class DealerSearch extends Component {
  static selector = '[comp-dealer-locator-search]';

  #debounceTimer = null;

  constructor(...args) {
    super(...args);
    this.events();
  }

  events() {
    this.$container.addEventListener('input', () => {
      clearTimeout(this.#debounceTimer);
      const query = this.$container.value.trim();

      if (query.length === 0) {
        document.dispatchEvent(new CustomEvent('dealer-locator:sort-reset'));
        return;
      }

      this.#debounceTimer = setTimeout(() => geocodeZip(query), DEBOUNCE_MS);
    });
  }
}
